// src/components/layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,        // ✅ Changed from FaTwitter to FaYoutube
  FaLinkedin,
  FaTiktok,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import logo from '../../assets/images/debaters.jpg';
import { oxford, learning, unihawk, toloita } from '../../assets';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    'Quick Links': [
      { name: 'About Us', to: '/about' },
      { name: 'Programs', to: '/programs' },
      { name: 'Gallery', to: '/gallery' },
      { name: 'Contact', to: '/contact' }
    ],
    Programs: [
      { name: 'Debate Training', to: '/programs' },
      { name: 'Public Speaking', to: '/programs' },
      { name: 'EAGLES CLUB', to: '/programs' },
      { name: 'Hackathon', to: '/programs' },
      { name: 'AIthon', to: '/programs' },
      { name: 'Storytelling', to: '/programs' }
    ],
    Support: [
      { name: 'Help Center', to: '#' },
      { name: 'Privacy Policy', to: '#' },
      { name: 'Terms of Service', to: '#' },
      { name: 'FAQ', to: '#' }
    ]
  };

  const socialLinks = [
    {
      icon: FaFacebook,
      url: 'https://www.facebook.com/TheAfricanChildDebatersLtd',
      name: 'Facebook',
      color: 'hover:text-blue-400'
    },
    {
      icon: FaInstagram,
      url: 'https://www.instagram.com/africanchilddebaters?igsh=MWhqams2ZDBiaDdocQ%3D%3D&utm_source=qr',
      name: 'Instagram',
      color: 'hover:text-pink-400'
    },
    {
      icon: FaYoutube,
      url: 'https://youtube.com/@africanchilddebaters?si=Xs2qGtjR7wph1EVT',
      name: 'YouTube',
      color: 'hover:text-red-500'
    },
    {
      icon: FaLinkedin,
      url: '#',  // Work in progress as per the report
      name: 'LinkedIn',
      color: 'hover:text-blue-600'
    },
    {
      icon: FaTiktok,
      url: 'https://www.tiktok.com/@african.child.debaters?_t=ZM90vIWxOfhyi&_r=1',
      name: 'TikTok',
      color: 'hover:text-pink-500'
    }
  ];

  const contactInfo = [
    {
      icon: FaEnvelope,
      text: 'info@africandebatechampions.org',
      href: 'mailto:info@africandebatechampions.org'
    },
    {
      icon: FaPhone,
      text: '+254 718 290 692',
      href: 'tel: +254 726 174 421'
    },
    {
      icon: FaMapMarkerAlt,
      text: 'Jewel Complex next to TRM Mall on Thika Rd, 4th Floor Office No. 413.',
      href: null
    }
  ];

  return (
    <footer className="relative bg-gray-50 mt-auto">
      {/* Main footer content */}
      <div className="bg-gray-50 pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Logo + About */}
            <div>
              <Link to="/" className="flex items-center group mb-4">
                <motion.div
                  className="relative"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <img
                    src={logo}
                    alt="The African Child Debaters Champions Ltd"
                    className="w-12 h-12 object-cover rounded-full border-3 border-green-500"
                    style={{
                      boxShadow: `
                        0 0 20px rgba(34, 197, 94, 0.4),
                        0 0 40px rgba(34, 197, 94, 0.2),
                        0 4px 15px rgba(0, 0, 0, 0.1)
                      `
                    }}
                  />
                  {/* Glowing ring effect */}
                  <div 
                    className="absolute inset-0 rounded-full border-2 border-green-300/50 animate-pulse"
                    style={{
                      boxShadow: '0 0 25px rgba(34, 197, 94, 0.3)'
                    }}
                  />
                </motion.div>
                <div className="ml-3">
                  <div className="text-gray-900 font-bold text-base">
                    The ACDC Ltd
                  </div>
                  <div className="text-green-600 text-sm -mt-1">
                    Empowering African Child Voices
                  </div>
                </div>
              </Link>
              <p className="text-gray-600 leading-relaxed text-sm">
                Nurturing confident, articulate, and well-rounded African children through world-class debate, public speaking, technology and creative programs.
              </p>
              <p className="text-gray-500 text-xs mt-3 font-medium">
                Debate. Lead. Change The World.
              </p>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-gray-900 font-semibold mb-4">Contact Us</h4>
              <div className="space-y-3">
                {contactInfo.map((info, index) => {
                  const Icon = info.icon;
                  return (
                    <div key={index} className="flex items-center space-x-3">
                      <Icon className="w-4 h-4 text-green-600" />
                      {info.href ? (
                        <a
                          href={info.href}
                          className="text-gray-600 hover:text-green-600 transition-colors text-sm"
                        >
                          {info.text}
                        </a>
                      ) : (
                        <span className="text-gray-600 text-sm">{info.text}</span>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-gray-500 text-xs font-medium mb-4">Our Partners:</p>
                <div className="flex items-center space-x-6">
                  <div className="relative">
                    <img 
                      src={learning} 
                      alt="a learning lab" 
                      className="w-12 h-8 rounded-md object-contain border border-gray-300 shadow-md bg-white px-1 transition-all duration-300 hover:shadow-green-500/30 hover:scale-105"
                      style={{
                        filter: 'drop-shadow(0 0 4px rgba(34, 197, 94, 0.2))'
                      }}
                    />
                  </div>
                  <div className="relative">
                    <img 
                      src={unihawk} 
                      alt="Unihawk" 
                      className="w-12 h-8 rounded-md object-contain border border-gray-300 shadow-md bg-white px-1 transition-all duration-300 hover:shadow-blue-500/30 hover:scale-105"
                      style={{
                        filter: 'drop-shadow(0 0 4px rgba(59, 130, 246, 0.2))'
                      }}
                    />
                  </div>
                  <div className="relative">
                    <img 
                      src={oxford} 
                      alt="Oxford Schools" 
                      className="w-12 h-8 rounded-md object-contain border border-gray-300 shadow-md bg-white px-1 transition-all duration-300 hover:shadow-purple-500/30 hover:scale-105"
                      style={{
                        filter: 'drop-shadow(0 0 4px rgba(147, 51, 234, 0.2))'
                      }}
                    />
                  </div>
                  <div className="relative">
                    <img 
                      src={toloita} 
                      alt="Toloita Tech" 
                      className="w-12 h-8 rounded-md object-contain border border-gray-300 shadow-md bg-white px-1 transition-all duration-300 hover:shadow-purple-500/30 hover:scale-105"
                      style={{
                        filter: 'drop-shadow(0 0 4px rgba(147, 51, 234, 0.2))'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Links */}
            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-gray-900 font-semibold mb-4">{title}</h4>
                <ul className="space-y-3">
                  {links.map((link, index) => (
                    <li key={index}>
                      <Link
                        to={link.to}
                        className="text-gray-600 hover:text-green-600 transition-colors text-sm"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Inverted U-shaped bottom section with mobile-friendly layout */}
      <div className="relative w-full flex justify-center">
        <div
          className="relative w-[85%] max-w-5xl h-auto sm:h-16 bg-gray-900/95 backdrop-blur-md flex flex-col sm:flex-row items-center justify-center px-6 py-4 sm:py-0"
          style={{
            borderTopLeftRadius: '2rem',
            borderTopRightRadius: '2rem',
            boxShadow: `
              0 -8px 32px rgba(0, 0, 0, 0.3),
              inset 0 0 0 1px rgba(255, 255, 255, 0.1)
            `
          }}
        >
          {/* Copyright */}
          <div className="flex items-center space-x-2 text-gray-400 text-sm mb-3 sm:mb-0">
            <span>© {currentYear} ACD</span>
            <span className="text-gray-600">•</span>
            <span className="text-green-400 font-medium">Toloita Technologies</span>
          </div>

          {/* Vertical divider - hidden on mobile */}
          <div className="hidden sm:block h-8 w-px bg-gray-600 mx-6"></div>

          {/* Social Links with better mobile spacing */}
          <div className="flex space-x-4 sm:space-x-3">
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-gray-400 ${social.color} transition-colors p-2.5 sm:p-2 rounded-full hover:bg-white/10`}
                  whileHover={{ scale: 1.15, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label={social.name}
                  style={{ zIndex: 10 }} // Ensure icons are above other elements
                >
                  <Icon className="w-4 h-4" />
                </motion.a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
